module.exports = __webpack_public_path__ + "media/images/sample/eyecatch-feature-sample-44ec4d8170eda8788a2f9583301fd14b.png";